export const folderConstants = {
  //List
   GETFOLDERS_REQUEST_LOADING: 'GET_FOLDERS_REQUEST_LOADING',
   GETFOLDERS_REQUEST_SUCCESS: 'GET_FOLDERS_REQUEST_SUCCESS',
   GETFOLDERS_REQUEST_FAILURE: 'GET_FOLDERS_REQUEST_FAILURE',
};
